export enum UrlsBack {
  getInmuebles ='http://srvwebprod01/Inmuebles_API/api/Inmuebles/Get',
  // getInmuebles = '/Inmuebles/OportunidadesInmobiliarias/GetInmueblesByFilters?idProvincia=0&idLocalidad=0&valor=0',
  // getInmuebleConFotos = '/Inmuebles/OportunidadesInmobiliarias/GetInmuebleWithBase64StringFilesById?id='
}

export enum UrlsFront {
  detalleInmueble = '/Detalle/:id'
}